import { ArrowRight } from 'lucide-react';
import { Slot } from '@radix-ui/react-slot';

import type { QuizPlayerControlsProps as QuizControlsProps } from './types';

import { useTranslation } from '@/providers/i18n';

import { Button } from '../button';
import { cn } from '../../lib/utils';

type QuizPlayerControlsProps = React.ComponentProps<'div'> &
  QuizControlsProps & {
    asChild?: boolean;
  };

export function QuizPlayerControls({
  onCancel,
  onConfirm = () => {},
  onNext,
  selectedAnswer,
  isAnswerValidated,
  isLastQuestion,
  requireConfirm,
  className,
  asChild,
  ...others
}: QuizPlayerControlsProps) {
  const { t } = useTranslation();
  const Comp = asChild ? Slot : 'div';

  const getButtonText = () => {
    if (!isAnswerValidated && requireConfirm)
      return t('quiz_player_confirm', t('confirm', 'Conferma'));
    if (isLastQuestion) return t('quiz_player_end', t('end', 'Fine'));
    return t('quiz_player_next', t('next', 'Successiva'));
  };

  const getButtonIcon = () => {
    if (!isAnswerValidated && requireConfirm) return null;
    if (isLastQuestion) return null;
    return <ArrowRight />;
  };

  const getButtonAction = () => {
    if (!isAnswerValidated && requireConfirm) return onConfirm;
    return onNext;
  };

  return (
    <Comp
      data-slot="quiz-player-controls"
      className={cn('flex justify-end', className)}
      {...others}
    >
      {(selectedAnswer || isAnswerValidated) && (
        <Button variant="brand" size="lg" onClick={getButtonAction()}>
          {getButtonText()} {getButtonIcon()}
        </Button>
      )}
    </Comp>
  );
}
